import mixpanel from 'mixpanel-browser';

const initMixpanel = () => {
  mixpanel.init(process.env.GATSBY_API_MIXPANEL_TOKEN, {
    api_host: process.env.GATSBY_MIXPANEL_HOST,
    debug: process.env.NODE_ENV === 'development',
    autocapture: true,
    record_sessions_percent: 100,
    record_heatmap_data: true,
    // Unmasks regular text on the page
    record_mask_all_text: false,
    record_mask_text_selector: '',
  });
};

export default initMixpanel;
